import React from 'react';
import {
    EuiBottomBar,
    EuiFlexGroup,
    EuiFlexItem,
    EuiButtonEmpty,
} from '@elastic/eui';

import linkedin from "../../logos/linkedin.svg"
import phone from '../../logos/phone.svg'
class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            position: 'static',
            isPopoverOpen: false
        }
    }

    render() {
        return (
            <>
            <EuiBottomBar position="sticky" paddingSize='s' style={{backgroundColor: '#2774AE'}}>
                <EuiFlexGroup gutterSize="m" justifyContent="center">
                <EuiFlexItem><EuiButtonEmpty size="xs" color="ghost" iconType={phone} href="#">+91 9921985369</EuiButtonEmpty></EuiFlexItem>
                <EuiFlexItem><EuiButtonEmpty size="xs" color="ghost" iconType='email' href="https://www.gmail.com" target="_blank">nikhilpawar.nik433@gmail.com</EuiButtonEmpty></EuiFlexItem>
                <EuiFlexItem><EuiButtonEmpty size="xs" color="ghost" iconType={linkedin} href="https://www.linkedin.com/in/nikhil-pawar-0655311a6" target="_blank">www.linkedin.com/nikhil-pawar-0655311A6</EuiButtonEmpty></EuiFlexItem>
                </EuiFlexGroup>
      </EuiBottomBar>
            </>
        );
    }
}

export { Footer }